import React from 'react';
import {Toaster} from 'react-hot-toast';

const ToastNotifications = () =>
  <Toaster
    position='top-center'
    toastOptions={{
      duration: 7500
    }}
  />;

export default ToastNotifications;